<template>
    <div>
        <ContentLink :href="engineer.profile_url">
            <ContentImage :src="engineer.last_cadfile_image_url"></ContentImage>
        </ContentLink>
        <EngineerInfo
                :id="engineer.id"
                :name="engineer.name"
                :profilePageUrl="engineer.profile_url"
                :avatarUrl="engineer.avatar_url"
                :followersCount="engineer.followers_count"
                :modelsCount="engineer.models_count"
                :tutorialsCount="engineer.tutorials_count">
        </EngineerInfo>
        <FollowButton class="follow-button" :followable-id="engineer.id" :following="engineer.following"
                      followable-type="member"></FollowButton>
    </div>
</template>

<script>
    import ContentImage from '../shared/card/ContentImage'
    import ContentLink from '../shared/card/ContentLink'
    import EngineerInfo from '../shared/card/EngineerInfo'
    import FollowButton from '../../../../shared/FollowButton'

    export default {
        name: 'Engineer',
        props: {
            engineer: Object
        },
        components: {
            FollowButton,
            ContentImage,
            EngineerInfo,
            ContentLink,
        },
        methods: {
            handleClose() {
                this.$eventHub.$emit('removeEngineer', this.engineer.id);
            },
        },
        mounted() {
            this.$parent.$on('cardClosed', this.handleClose);
        }
    }
</script>

<style lang="scss" scoped>
    .follow-button {
        margin-top: 10px;
    }
</style>
